let { Query } = require('catberry-uri');
let utils = require('../helpers/utils');
let bitrix = require('./bitrix');

module.exports = {
    /**
     * Редирект на определенный url
     * @param {String} url
     * @param {Number} delay
     * @returns {redirect}
     */
    redirect (url, delay = 0) {
        return function redirect (args, state, output, { context, locator }) {
            if (context.isServer) {
                return;
            }

            var location = utils.patchQueryWithUtm(url, state);

            if (delay > 0) {
                window.setTimeout(function () {
                    context.redirect(location);
                }, delay);
            } else {
                context.redirect(location);
            }

            if (state.get(['bitrix', 'isBitrix'])) {
                bitrix.fitWindow(args, state, output, { locator });
            }
        };
    },

    redirectFromArgs (args, state, output, { context }) {
        if (context.isServer) {
            return;
        }

        let location = utils.patchQueryWithUtm(args.url, state);
        let delay = args.delay || 0;

        if (delay > 0) {
            window.setTimeout(function () {
                context.redirect(location);
            }, delay);
        } else {
            context.redirect(location);
        }
    },

    redirectToRoot (args, state, output, { context }) {
        let root = state.get(['bitrix', 'isBitrix']) === true ? '/bitrix' : '/';
        context.redirect(root);
    },

    /**
     * Редирект на стороне клиента с перезагрузкой страницы
     * @param {String} url
     * @param {Number} delay
     * @returns {redirect}
     */
    locationRedirect (url, delay = 0) {
        return function redirect (args, state, output, { context }) {
            if (context.isServer) {
                return;
            }

            var location = utils.patchQueryWithUtm(url, state);

            if (delay > 0) {
                window.setTimeout(function () {
                    window.location = location;
                }, delay);
            } else {
                window.location = location;
            }
        };
    },

    /**
     * Редирект на стороне клиента с перезагрузкой страницы
     * @param {String} url
     * @param {String} subPath
     * @param {Number} delay
     * @returns {redirect}
     */
    locationRedirectToOrder (url, subPath, delay = 0) {
        return function redirect (args, state, output, { context }) {
            if (context.isServer) {
                return;
            }

            var location = utils.patchQueryWithUtm(url + args[subPath], state);

            if (delay > 0) {
                window.setTimeout(function () {
                    window.location = location;
                }, delay);
            } else {
                window.location = location;
            }
        };
    },

    /**
     * Записывает значение из аргумента в URL без вызова сигнала
     * @param {String} argsKey
     * @param {String} queryKey
     * @return {Function}
     */
    patchURLQuery (argsKey, queryKey) {
        return function patchURLQuery (args, state, output, { context }) {
            let key = args[argsKey];
            let location = context.location.clone();

            if (!location.query) {
                location.query = new Query();
            }

            if (!location.query.values) {
                location.query.values = {};
            }

            location.query.values[queryKey] = key;
            let locationString = location.toString();
            context.redirect(utils.patchQueryWithUtm(locationString, state), { silent: true });
        };
    },

    /**
     * Записывает значение переданной строки в URL без вызова сигнала
     * @param {Array} statePath
     * @param {String} absPath
     * @return {Function}
     */
    queryRedirectFromState (statePath, absPath = '') {
        return function patchURLQuery (args, state, output, { context }) {
            let query = state.get(statePath);

            context.redirect(utils.patchQueryWithUtm(`${absPath}?${query}`, state), { silent: true });
        };
    },

    /**
     * Записывает в URL адрес выбранного заказа без вызова сигнала
     * @param {Array} statePath
     * @return {Function}
     */
    queryOrderRedirect (statePath) {
        return function patchURLQuery ({ orderId }, state, output, { context }) {
            if (context.isServer) {
                return;
            }
            let query = state.get(statePath);
            let role = state.get(['user', 'role']);
            let pageName = 'account';
            if (role === 'manager') {
                pageName = 'manager';
            }
            context.redirect(
                utils.patchQueryWithUtm(`/${pageName}/orders/${orderId}?${query}`, state),
                { silent: true });
        };
    }
};



// WEBPACK FOOTER //
// ./actions/redirect.js